import React from 'react'

import { useTranslation } from 'language/translator'
import {
  translateTextAlign,
  translateTextVerticalAlign
} from 'utils/enumTranslator'

/* Atoms */
import Grid from 'components_new/atoms/Grid'

/* Molecules */
import SettingsGroup from 'components_new/molecules/SettingsGroup'
import SettingsItem from 'components_new/molecules/SettingsItem'
import SettingsToggleOption from 'components_new/molecules/SettingsToggleOption'

/* Types */
import {
  InnerWidgetPatchBody,
  TextAlign,
  TextVerticalAlign
} from 'types/GlobalWidget'

interface TextSectionProps {
  textAlign: TextAlign
  textVerticalAlign: TextVerticalAlign
  updateWidget: (body: InnerWidgetPatchBody) => void
}

const TextSection = (props: TextSectionProps) => {
  const { textAlign, textVerticalAlign, updateWidget } = props

  const { t, translateEnum } = useTranslation()

  return (
    <>
      <SettingsGroup title={t('widgets', 'horizontal_text_alignment')}>
        <SettingsItem>
          <Grid container={true} columns={3}>
            {Object.values(TextAlign).map((option) => {
              const selected = textAlign === option

              return (
                <Grid item={true} key={option} xs={1}>
                  <SettingsToggleOption
                    iconName={translateTextAlign[option].iconName}
                    onClick={() => updateWidget({ text_align: option })}
                    selected={selected}
                    title={translateEnum('text_aligns', option)}
                  />
                </Grid>
              )
            })}
          </Grid>
        </SettingsItem>
      </SettingsGroup>
      <SettingsGroup title={t('widgets', 'vertical_text_alignment')}>
        <SettingsItem>
          <Grid container={true} columns={3}>
            {Object.values(TextVerticalAlign).map((option) => {
              const selected = textVerticalAlign === option

              return (
                <Grid item={true} key={option} xs={1}>
                  <SettingsToggleOption
                    iconName={translateTextVerticalAlign[option].iconName}
                    onClick={() =>
                      updateWidget({ text_vertical_align: option })
                    }
                    selected={selected}
                    title={translateEnum('text_vertical_aligns', option)}
                  />
                </Grid>
              )
            })}
          </Grid>
        </SettingsItem>
      </SettingsGroup>
    </>
  )
}

export default TextSection
